{
  "insightId": "hVJ18fItlltk",
  "kind": 1,
  "computationKind": 3,
  "dxObject": { "id": "ey1aPZNpy7uZ", "version": "1657584868794", "supportedDxObjectType": 1 },
  "computedAt": "2022-09-14T18:06:16.020685511Z",
  "computationHash": "testComputationHash",
  "start": "2022-08-17T04:00:00Z",
  "end": "2022-09-14T04:00:00Z",
  "createdAt": "2022-09-14T18:06:16.097234Z",
  "updatedAt": "2022-09-14T18:06:16.097234Z",
  "trend": {
    "data": {
      "metricsDataTable": {
        "table": [
          {
            "startTime": "2022-08-16T04:00:00Z",
            "endTime": "2022-08-17T04:00:00Z",
            "groups": [],
            "value": 0.15949227373068434,
            "isPartialPeriod": true
          },
          {
            "startTime": "2022-08-17T04:00:00Z",
            "endTime": "2022-08-18T04:00:00Z",
            "groups": [],
            "value": 0.1676980198019802,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-08-18T04:00:00Z",
            "endTime": "2022-08-19T04:00:00Z",
            "groups": [],
            "value": 0.1810070108349267,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-08-19T04:00:00Z",
            "endTime": "2022-08-20T04:00:00Z",
            "groups": [],
            "value": 0.17604712041884818,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-08-20T04:00:00Z",
            "endTime": "2022-08-21T04:00:00Z",
            "groups": [],
            "value": 0.1847898599066044,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-08-21T04:00:00Z",
            "endTime": "2022-08-22T04:00:00Z",
            "groups": [],
            "value": 0.18193717277486912,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-08-22T04:00:00Z",
            "endTime": "2022-08-23T04:00:00Z",
            "groups": [],
            "value": 0.18915510718789408,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-08-23T04:00:00Z",
            "endTime": "2022-08-24T04:00:00Z",
            "groups": [],
            "value": 0.17093311312964493,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-08-24T04:00:00Z",
            "endTime": "2022-08-25T04:00:00Z",
            "groups": [],
            "value": 0.18434670116429497,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-08-25T04:00:00Z",
            "endTime": "2022-08-26T04:00:00Z",
            "groups": [],
            "value": 0.1958702064896755,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-08-26T04:00:00Z",
            "endTime": "2022-08-27T04:00:00Z",
            "groups": [],
            "value": 0.18979057591623036,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-08-27T04:00:00Z",
            "endTime": "2022-08-28T04:00:00Z",
            "groups": [],
            "value": 0.19133333333333333,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-08-28T04:00:00Z",
            "endTime": "2022-08-29T04:00:00Z",
            "groups": [],
            "value": 0.1853562005277045,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-08-29T04:00:00Z",
            "endTime": "2022-08-30T04:00:00Z",
            "groups": [],
            "value": 0.18170426065162906,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-08-30T04:00:00Z",
            "endTime": "2022-08-31T04:00:00Z",
            "groups": [],
            "value": 0.16655607166556072,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-08-31T04:00:00Z",
            "endTime": "2022-09-01T04:00:00Z",
            "groups": [],
            "value": 0.17900403768506057,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-09-01T04:00:00Z",
            "endTime": "2022-09-02T04:00:00Z",
            "groups": [],
            "value": 0.17220902612826602,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-09-02T04:00:00Z",
            "endTime": "2022-09-03T04:00:00Z",
            "groups": [],
            "value": 0.1943532501641497,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-09-03T04:00:00Z",
            "endTime": "2022-09-04T04:00:00Z",
            "groups": [],
            "value": 0.18787878787878787,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-09-04T04:00:00Z",
            "endTime": "2022-09-05T04:00:00Z",
            "groups": [],
            "value": 0.1906040268456376,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-09-05T04:00:00Z",
            "endTime": "2022-09-06T04:00:00Z",
            "groups": [],
            "value": 0.18538205980066444,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-09-06T04:00:00Z",
            "endTime": "2022-09-07T04:00:00Z",
            "groups": [],
            "value": 0.18212593094109683,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-09-07T04:00:00Z",
            "endTime": "2022-09-08T04:00:00Z",
            "groups": [],
            "value": 0.1843137254901961,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-09-08T04:00:00Z",
            "endTime": "2022-09-09T04:00:00Z",
            "groups": [],
            "value": 0.19110816191108163,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-09-09T04:00:00Z",
            "endTime": "2022-09-10T04:00:00Z",
            "groups": [],
            "value": 0.18713826366559486,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-09-10T04:00:00Z",
            "endTime": "2022-09-11T04:00:00Z",
            "groups": [],
            "value": 0.1875834445927904,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-09-11T04:00:00Z",
            "endTime": "2022-09-12T04:00:00Z",
            "groups": [],
            "value": 0.1868720696584059,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-09-12T04:00:00Z",
            "endTime": "2022-09-13T04:00:00Z",
            "groups": [],
            "value": 0.1908548707753479,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-09-13T04:00:00Z",
            "endTime": "2022-09-14T04:00:00Z",
            "groups": [],
            "value": 0.1889920424403183,
            "isPartialPeriod": false
          }
        ],
        "numGroups": "0"
      }
    },
    "direction": 2,
    "periodicStats": [
      {
        "startDate": "2022-08-17T04:00:00Z",
        "endDate": "2022-08-24T04:00:00Z",
        "variability": { "stdUpper": 0.185871858760942, "stdLower": 0.17171882811184871 }
      },
      {
        "startDate": "2022-08-24T04:00:00Z",
        "endDate": "2022-08-31T04:00:00Z",
        "variability": { "stdUpper": 0.19371838765983906, "stdLower": 0.17626942655399763 }
      },
      {
        "startDate": "2022-08-31T04:00:00Z",
        "endDate": "2022-09-07T04:00:00Z",
        "variability": { "stdUpper": 0.1914100157562551, "stdLower": 0.1776063040847915 }
      },
      {
        "startDate": "2022-09-07T04:00:00Z",
        "endDate": "2022-09-14T04:00:00Z",
        "variability": { "stdUpper": 0.1903421624662618, "stdLower": 0.18590428854337682 }
      }
    ],
    "ratioChange": 0.3214985960666935
  }
}
